var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4825 21.2693L17.7872 2.85853C17.1019 1.68071 15.8701 0.974854 14.4996 0.974854C13.129 0.974854 11.8972 1.68071 11.212 2.85853L0.512489 21.2693C-0.172783 22.4513 -0.172783 23.8588 0.512489 25.0408C1.19776 26.2228 2.42536 26.9245 3.80011 26.9245H25.1949C26.5654 26.9245 27.7972 26.2186 28.4825 25.0408C29.172 23.8588 29.172 22.4471 28.4825 21.2693ZM2.80794 22.5849L13.5074 4.17418C13.7134 3.81916 14.0876 3.60615 14.4996 3.60615C14.9158 3.60615 15.2858 3.81916 15.4918 4.17418L26.1912 22.5849C26.3972 22.9399 26.3972 23.366 26.1912 23.7252C25.9852 24.0802 25.6111 24.2932 25.1991 24.2932H3.80011C3.3839 24.2932 3.01394 24.0802 2.80794 23.7252C2.60194 23.3701 2.60194 22.9399 2.80794 22.5849Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 17.0007C15.2316 17.0007 15.8244 16.4117 15.8244 15.685V9.16941C15.8244 8.44267 15.2316 7.85376 14.5001 7.85376C13.7686 7.85376 13.1758 8.44267 13.1758 9.16941V15.685C13.1758 16.4076 13.7686 17.0007 14.5001 17.0007Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 22.0546C15.3828 22.0546 16.0975 21.3446 16.0975 20.4675C16.0975 19.5904 15.3786 18.8804 14.4999 18.8804C13.6212 18.8804 12.9023 19.5904 12.9023 20.4675C12.9023 21.3446 13.617 22.0546 14.4999 22.0546Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25.9496,
    fill: "currentColor",
    transform: "translate(0 0.974854)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bacac5add950fcbdb6a9d560d6762b41.svg";
export { ForwardRef as ReactComponent };